module.exports = __webpack_public_path__ + "img/VL_03_02.e9ce8c5d.png";